module.exports = __webpack_public_path__ + "static/media/LazyAz_web4.398e9425.jpg";